import {
  type ReactElement, useState, type MouseEvent, type FC,
} from 'react';

import { AvatarWrapper, UserLabel } from 'components/_Navbar/User/index.styled';
import UserAvatar from 'components/UserAvatar';
import UserMenu from 'components/UserMenu';

import { useLogout } from 'hooks/useLogout';
import { useAppSelector } from 'hooks/useRedux';
import { loggedUserSelector } from 'store/user/selectors';

import ChevronDownIcon from 'assets/icons/ChevronDownIcon';

interface UserProps {
  isMini?: boolean;
}

const User:FC<UserProps> = ({ isMini = false }): ReactElement => {
  const loggedUser = useAppSelector(loggedUserSelector);
  const { logout } = useLogout();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: MouseEvent<HTMLDivElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <AvatarWrapper onClick={handleOpenMenu} isActive={Boolean(anchorEl)}>
        <UserAvatar id="avatar-loggedUser" userInitials={loggedUser?.email?.[0]?.toUpperCase() || ''} />

        {!isMini && (
          <>
            <UserLabel id="text-username" variant="body2" ml={4} className="text-ellipsis">
              {loggedUser?.email}
            </UserLabel>
            <ChevronDownIcon id="icon-chevronDown" size={20} />
          </>
        )}
      </AvatarWrapper>
      <UserMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        onLogout={logout}
      />
    </>
  );
};

export default User;
